import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import SideDrawer from '../../common/components/sideDrawer/SideDrawer';
import { fontSize, spacing, textColor } from '../../theming';
import { cardTitleStyle } from './vinExtractionStyles';
import CarStatusTag from './CarStatusTag';
import NoValue from './NoValue';
import CarDocuments from './CarDocuments';
import CarInfo from './CarInfo';
import CarDrawerHeader from './CarDrawerHeader';
import CarFailedNav from './CarFailedNav';
import CarAttempts from './CarAttempts';

/**
 * One car of a batch (from the cars panel's rows): status, Current VIN (`a1_cars.vin`), document links and one card
 * per attempt. `failedNav` (useFailedCarNav) only when opened from the Failed tab; otherwise no nav and no "k of N".
 */
export default function CarDrawer({ open, onClose, car, batch, currentThreshold, failedNav }) {
    const { t } = useTranslation('vinExtraction');
    // E17: a legacy batch has no snapshot → the current setting, labelled "(current)"
    const snapshot = batch?.snapshot ?? null;
    const threshold = snapshot ? snapshot.confidenceThreshold : currentThreshold ?? null;
    const name = car ? [car.manufacturer, car.model].filter(Boolean).join(' ') : '';

    return (
        <SideDrawer
            open={open}
            closeDrawer={onClose}
            title={car ? <CarDrawerHeader car={car} failedNav={failedNav} /> : null}
        >
            {car && (
                <Flex vertical gap={spacing[3]}>
                    <Flex align="center" gap={spacing[1]} wrap="wrap">
                        <span style={{ ...cardTitleStyle, fontSize: fontSize.md, color: textColor.primary }}>
                            {name || <NoValue label={t('drawer.noName')} />}
                        </span>
                        <CarStatusTag status={car.status} />
                    </Flex>
                    <CarInfo car={car} batch={batch} />
                    <CarDocuments carId={car.carId} open={open} />
                    <Flex vertical gap={spacing[2]}>
                        <h3 style={{ ...cardTitleStyle, margin: 0 }}>{t('drawer.attempts')}</h3>
                        <CarAttempts car={car} threshold={threshold} thresholdIsCurrent={!snapshot} />
                    </Flex>
                    {failedNav && <CarFailedNav nav={failedNav} />}
                </Flex>
            )}
        </SideDrawer>
    );
}
